/**
 * Welcome offer popup behavior.
 */
(function () {
  var KEY = 'togekid_welcome_popup';
  var root = document.getElementById('WelcomePopup');
  if (!root) return;
  var isEditor = window.Shopify && Shopify.designMode;
  var rootUrl = root.getAttribute('data-root-url') || '/';
  var codeUrl = root.getAttribute('data-code-url');

  function seen() {
    try { return !!localStorage.getItem(KEY); } catch (e) { return false; }
  }
  function markSeen() { try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {} }
  function open() { root.hidden = false; }
  function close() { root.hidden = true; markSeen(); }

  function showCode(code) {
    var slot = root.querySelector('[data-wpop-code-slot]');
    if (slot) slot.textContent = code;
    var copyBtn = root.querySelector('[data-wpop-copy]');
    if (copyBtn) {
      copyBtn.hidden = false;
      copyBtn.setAttribute('data-wpop-copy-value', code);
    }
    root.querySelector('[data-wpop-step="form"]').hidden = true;
    root.querySelector('[data-wpop-step="code"]').hidden = false;
  }

  function fetchAndShowCode() {
    if (!codeUrl) return;
    fetch(codeUrl, { cache: 'no-store' })
      .then(function (res) { return res.json(); })
      .then(function (data) { showCode(data && data.code ? data.code : ''); })
      .catch(function () { showCode(''); });
  }

  root.querySelectorAll('[data-wpop-close]').forEach(function (el) {
    el.addEventListener('click', close);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !root.hidden) close(); });

  var form = root.querySelector('.wpop__form');
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var email = root.querySelector('.wpop__email').value.trim();
    if (!email) return;
    // Subscribe to the customer list (best effort), then fetch + reveal the code.
    var body = new URLSearchParams();
    body.append('form_type', 'customer');
    body.append('utf8', '✓');
    body.append('contact[email]', email);
    body.append('contact[tags]', 'newsletter, welcome-popup');
    fetch(rootUrl, { method: 'POST', body: body, headers: { 'Accept': 'text/html' } })
      .catch(function () {})
      .finally(fetchAndShowCode);
    markSeen();
  });

  var copyBtn = root.querySelector('[data-wpop-copy]');
  if (copyBtn) {
    copyBtn.addEventListener('click', function () {
      var code = copyBtn.getAttribute('data-wpop-copy-value');
      if (!code) return;
      if (navigator.clipboard) { navigator.clipboard.writeText(code); }
      copyBtn.textContent = 'Copied!';
    });
  }

  if (isEditor) { open(); return; }       // always show in theme editor preview
  if (seen()) return;

  var opened = false;
  function maybeOpen() {
    if (opened) return;
    opened = true;
    open();
  }

  // Show after 20s for everyone.
  var delayTimer = setTimeout(maybeOpen, 20000);

  // Exit intent (desktop only): open immediately instead of waiting out
  // the 20s if the cursor heads off the top of the page.
  if (window.matchMedia && window.matchMedia('(min-width: 750px)').matches) {
    document.addEventListener('mouseout', function (e) {
      if (opened) return;
      if (e.clientY <= 0 && !e.relatedTarget) {
        clearTimeout(delayTimer);
        maybeOpen();
      }
    });
  }
})();
